var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCanceled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 8,
    fill: "#FF4728"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.84111 5.1034C5.63466 4.95022 5.34169 4.96724 5.15446 5.15446C4.94851 5.36041 4.94851 5.69431 5.15446 5.90026L7.2542 8L5.15446 10.0997C4.94851 10.3057 4.94851 10.6396 5.15446 10.8455C5.34169 11.0328 5.63466 11.0498 5.84111 10.8966L5.90026 10.8455L8 8.7458L10.0997 10.8455L10.1589 10.8966C10.3653 11.0498 10.6583 11.0328 10.8455 10.8455C11.0515 10.6396 11.0515 10.3057 10.8455 10.0997L8.7458 8L10.8455 5.90026C11.0515 5.69431 11.0515 5.36041 10.8455 5.15446C10.6583 4.96724 10.3653 4.95022 10.1589 5.1034L10.0997 5.15446L8 7.2542L5.90026 5.15446L5.84111 5.1034Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanceled);
export default __webpack_public_path__ + "static/media/canceled.21e79e22542a78c3255b6da30939d5a8.svg";
export { ForwardRef as ReactComponent };